import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';

/**
 * Generated class for the EditpredefinednotesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-editpredefinednotes',
  templateUrl: 'editpredefinednotes.html',
})
export class EditpredefinednotesPage {
  Title = ''
  _name = ''
  pd: any
  myToast: any
  _orgid = 0
  DriversData = []
  _employeeid = 0
  selectedDriver = ''
  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public alertCtrl: AlertController, public toastCtrl: ToastController) {
    this.pd = navParams.get('pd')
    this.DriversData.push({ id: 0, name: '-- ' + this.dic.l["ChooseDriverR"] + ' --' })
    if (this.pd.id == -1) {
      this.Title = this.dic.l["addPredNote"]
    } else {
      this._name = this.pd.name
      this._orgid = this.pd.orgid
      if (this._orgid == null) {
        this._orgid = 0
      }
      this._employeeid = this.pd.employeeid
      if (this._employeeid == null) {
        this._employeeid = 0
      }
      this.Title = this.dic.l["editPredNote"] + ' ' + this._name
    }
    if (this._employeeid == 0) {
      this.selectedDriver = '-- ' + this.dic.l["ChooseDriverR"] + ' --'
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EditpredefinednotesPage');
    this.getAllDrivers()
  }

  Save() {
    if (this.myToast != null) {
      return
    }

    if (this._name + '' == "") {
      let alert = this.alertCtrl.create({ title: this.dic.l["error"], subTitle: this.dic.l["addname"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }

    var _dat = {
      id: this.gn.crypt(this.pd.id),
      name: this.gn.crypt(this._name),
      cid: this.gn.crypt(this.gn.user.ClientId),
      employeeid: this.gn.crypt(this._employeeid),
      orgid: this.gn.crypt(this._orgid)

    }
    var _that = this
    _that.gn.loadWaiting();
    this.gn._Post('/api/gn/insertPredNote', _dat, function (_data) {
      _that.gn.loaderWaiting.dismiss();
      var _cb = _that.navParams.get('cb')
      if (_cb != null) {
        _cb()
      }
      var _msg = _that.dic.l["succaddPredNote"]
      if (_that.pd.id + '' != '-1') {
        _msg = _that.dic.l["succEditPredNote"]
      }
      let toast = _that.toastCtrl.create({
        message: _msg,
        duration: 3000,
        position: 'top'
      });
      toast.present();
      _that.navCtrl.pop()
    })
  }


  getAllDrivers() {
    // if (this.gn.user.ClientId == 709 || this.gn.user.ClientId + '' == '685') {
    //   var _that = this
    //   // _that.DriversData.push({id: 0, name: '-- '+this.dic.l["ChooseDriver"]+' --'})
    //   this.gn._Post('/api/gn/getalldriversanalytics', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
    //     for (var i = 0; i < _data.length; i++) {
    //       _that.DriversData.push({ id: _data[i].id, name: _data[i].fullname, distcurr: _data[i].distcurr, distlast: _data[i].distlast, available: 0 })

    //     }
    //     // console.log(_data)
    //   })
    // } else {
    var _that = this
    // _that.DriversData.push({id: 0, name: '-- '+this.dic.l["ChooseDriver"]+' --'})
    this.gn._Post('/api/gn/getalldrivers', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      for (var i = 0; i < _data.length; i++) {
        _that.DriversData.push({ id: _data[i].id, name: _data[i].fullname })
        if (_that.pd.id != -1 && _that._employeeid != 0 && _data[i].id == _that._employeeid) {
          _that.selectedDriver = _data[i].fullname
        }
      }

      // console.log(_data)
    })
    // }

  }

  selectDriverOne(_ev) {
    var _that = this
    let alert = this.alertCtrl.create();
    alert.setTitle(this.dic.l["ChooseDriverR"]);

    for (var i = 0; i < this.DriversData.length; i++) {
      var ch = false
      if (this.DriversData[i].id + '' == this._employeeid + '') {
        ch = true
      }
      alert.addInput({
        type: 'radio',
        label: this.DriversData[i].name,
        value: this.DriversData[i].id,
        checked: ch
      });
    }

    alert.addButton(this.dic.l['cancel']);
    alert.addButton({
      text: this.dic.l['ok'],
      handler: data => {
        this._employeeid = data
        if (data == 0) {
          _that.selectedDriver = '-- ' + _that.dic.l["ChooseDriverR"] + ' --'
        } else {
          for (var i = 0; i < _that.DriversData.length; i++) {
            console.log(_that.DriversData[i].id + '', '----------', data + '')
            if (_that.DriversData[i].id + '' == data + '') {
              _that.selectedDriver = _that.DriversData[i].name
            }
          }
        }
      }
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/settings/predefinednotes/editpredefinednotes.ts